import React from "react";

const Line = () => {
  return (
    <hr
      style={{
        color: "#303F9F",
        backgroundColor: "#303F9F",
        height: 0.25,
        width: "100%",
      }}
    />
  );
};
export default Line;
